<template>
  <div :class="`flex justify-center items-center mb-16 ${noHorizontalPadding ? 'px-0' : 'px-6 lg:px-24'}`">
    <Carousel
      class="w-full"
      :opts="{
        loop: true,
      }"
    >
      <CarouselContent>
        <template v-if="featuredShops.length > 0">
          <CarouselItem v-for="store in featuredShops" :key="store?.id">
            <FeaturedStoreCard
              :id="store?.id"
              :name="store?.name"
              :logo="store?.logo"
              :createdAt="store?.createdAt"
              :loading="loading"
              :domain="store?.domain"
            />
          </CarouselItem>
        </template>
        <CarouselItem v-else>
          <FeaturedStoreCard
            :id="undefined"
            :name="undefined"
            :logo="undefined"
            :createdAt="undefined"
            :loading="loading"
            :domain="undefined"
          />
        </CarouselItem>
      </CarouselContent>
      <CarouselPrevious
        class="hidden md:flex mt-4 absolute top-auto bottom-6 left-4 text-white bg-transparent border-0 hover:bg-transparent hover:text-white"
      >
        <ChevronLeft />
      </CarouselPrevious>
      <CarouselNext
        class="hidden md:flex ml-auto mt-4 absolute top-auto bottom-6 right-4 text-white bg-transparent border-0 hover:bg-transparent hover:text-white"
      >
        <ChevronRight />
      </CarouselNext>
      <CarouselDotButtons class="mt-4 absolute bottom-12 left-1/2 -translate-x-1/2" selected-class="border-white" />
    </Carousel>
  </div>
</template>

<script setup lang="ts">
import FeaturedStoreCard from '@/components/FeaturedStoreCard.vue';
import { Carousel, CarouselContent, CarouselDotButtons, CarouselItem } from '@/components/ui/carousel';
import { useShopsStore } from '@/stores/shop';
import { ChevronLeft, ChevronRight } from 'lucide-vue-next';
import { storeToRefs } from 'pinia';
import CarouselNext from './ui/carousel/CarouselNext.vue';
import CarouselPrevious from './ui/carousel/CarouselPrevious.vue';

withDefaults(
  defineProps<{
    noHorizontalPadding?: boolean;
  }>(),
  { noHorizontalPadding: true },
);

const shopsStore = useShopsStore();
const { featuredShops, loading } = storeToRefs(shopsStore);
</script>
